const base_url =
  window.location.hostname === "localhost"
    ? "http://localhost:5000/api" // Local URL
    : "https://rxconnect.space/sandyrandhawa/backend/api"; // Production URL

export default base_url;

